<template>
  <v-dialog
  v-model="reporteFechas.status"
  persistent
  max-width="1000"
  >
  <v-card>
    <v-card-title primary-title class="text-subtitle-1">
      Reporte de pagos por fecha
    </v-card-title>
    <v-card-text >

      	<v-row>

          <v-col cols="12" class="pb-0">
            <div style="width: fit-content;">
              <label>Selecciona un ciclo</label>
              <v-autocomplete
                label="Ciclo"
                id="id"
                filled
                dense
                single-line
                hide-details
                v-model="ciclo"
                :items="ciclos"
                item-text="ciclo"
                item-value="id_ciclo"
                clearable
              ></v-autocomplete>
            </div>
          </v-col>

      		<v-col cols="12" md="6" lg="4">
		        <v-text-field
		          v-model="fechaini"
		          dense
		          filled
		          type="date"
		          label="Fecha inicio"
		          clearable
		        ></v-text-field>
      		</v-col>

      		<v-col cols="12" md="6" lg="4">
		        <v-text-field
		          v-model="fechafin"
		          dense
		          filled
		          type="date"
		          label="Fecha final"
		          clearable
		        ></v-text-field>
      		</v-col>
      		<v-col cols="12" md="6" lg="4">
      			<v-btn
              color="orange"
              dark
              @click="initialize"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
            <v-btn
              class="ml-2"
              small dark color="green"
              @click="exportExcel(reporte, 'reporte-pago-por-fecha')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>
      		</v-col>
      	</v-row>

        <v-col cols="12" md="3" lg="3">
          <span class="black--text text-h8">
            <b>Movimientos:</b>
              | {{ movimientosReporte }} |
          </span>
          <br/>
          <span class="black--text text-h8">
            <b>Revisados:</b>
              | {{ revisadosReporte }} |
          </span>
          <br/>
          <span class="black--text text-h8">
            <b>Faltantes:</b>
            | {{ faltantesReporte }} |
          </span>
          <br/>
          <span class="black--text text-h8">
            <b>% Revisados:</b>
              | {{ porcentajeReporte }}% |
          </span>
        </v-col>

        <v-data-table
          :headers="headersReporte"
          :items="reporte"
          class="elevation-0"
          dense
          :search="search"
        >
          <template v-slot:item.porcentaje="{ item }">
            {{ item.porcentaje }}%
          </template>
        </v-data-table>
      </v-card-text>
    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
        	color="black"
        	dark
        	tile
        	@click="cerrar()"
        >Cancelar</v-btn>
      </v-card-actions>
  </v-card>

  <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>
  </v-dialog>
</template>

<script>
import axios from 'axios';
// Componentes
import Alerta                from '@/components/alertas/Alerta.vue';
import carga                 from '@/components/alertas/carga.vue';

import validarErrores        from '@/mixins/validarErrores'
import { mapGetters, mapActions }  from 'vuex';
import funcionesExcel        from '@/mixins/funcionesExcel'

export default {

  components:{
      Alerta,
      carga,
  },
  mixins: [ validarErrores, funcionesExcel ],
  props: [
    'reporteFechas',
    'ciclos'
  ],

  data: () => ({

    // Alertas
    parametros:{
      dialogError: false,
      mensaje: '',
      color: ''
    },

    respuestaAlerta:false,
    loader: true,
    cargar: false,

    fechaini: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
		fechafin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    headersReporte: [
      { text: "id_usuario_ultimo_cambio", value: "id_usuario_ultimo_cambio"},
        { text: "registro", value: "nombre_completo"},
	      { text: "movimientos", value: "movimientos"},
	      { text: "revisados", value: "revisados"},
	      { text: "faltantes", value: "faltantes"},
	      { text: "% revisados", value: "porcentaje"},
    ],
    search: '',
    reporte: [],
    movimientosReporte: 0,
    revisadosReporte: 0,
    faltantesReporte: 0,
    porcentajeReporte: 0,
    ciclo: null,
  }),
  created(){
    this.initialize()
  },
  methods: {
    initialize(){
      let payload = {
        id_ciclo: this.ciclo,
        fecha_inicio: this.fechaini,
        fecha_final: this.fechafin,
      }

      this.cargar = true;
      this.reporte = []

      this.$http.post("movimientos.corte", payload )
      .then((response) => {
        response.data.map(d => {
          const existente = this.reporte.find(r => r.id_usuario_ultimo_cambio === d.id_usuario_ultimo_cambio);
          if (existente) {
            // Si ya existe, actualizamos los valores según sea necesario
            existente.movimientos += 1;
            if( d.aceptado ) existente.revisados += 1;
            if( !d.aceptado ) existente.faltantes += 1;
            // Calcular porcentaje al final
          } else {
            // Si no existe, lo agregamos con valores iniciales
            this.reporte.push({
              id_usuario_ultimo_cambio: d.id_usuario_ultimo_cambio,
              nombre_completo: d.nombre_completo,
              movimientos: 1,
              revisados: d.aceptado ? 1 : 0,
              faltantes: !d.aceptado ? 1 : 0,
              porcentaje: 0
            });
          }
        })

        this.movimientosReporte = response.data.length;
        this.revisadosReporte = response.data.filter( el => { return el.aceptado }).length;
        this.faltantesReporte = response.data.filter( el => { return !el.aceptado }).length;
        const porcentaje = ( response.data.filter( el => { return el.aceptado }).length / response.data.length ) * 100;
        this.porcentajeReporte = porcentaje.toFixed(1);

        // Porcentajes de reporte
        this.reporte.map(d => {
          d.porcentaje = ( ( ( d.revisados || 0 ) / ( d.movimientos  || 0 ) ) * 100 ).toFixed(1) || 0;
        })

        this.cargar = false;
      })
      .catch( error =>{
        this.validarError( error.response.data.message )
      })
      .finally( () => { this.cargar = false })
    },
    exportar( ){
      this.exportExcel( this.reporte  , 'reportePagosPorFecha')
    },
    cerrar(){
      this.fechaini = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      this.fechafin = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      this.reporte = []
      this.movimientosReporte = 0
      this.revisadosReporte = 0
      this.faltantesReporte = 0
      this.porcentajeReporte = 0
      this.ciclo = null
      this.initialize()
      this.reporteFechas.status = false
    },
  }
}
</script>
